import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import {
  CreditNoteOperationResult,
  CreditNoteDataEntity,
} from "../entities/CreditNoteEntity";

/**
 * Update Zoho Credit Note Use Case
 * Updates a credit note in Zoho Books
 */
export class UpdateZohoCreditNoteUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(
    creditNoteId: number | string,
    creditNoteData: CreditNoteDataEntity
  ): Promise<CreditNoteOperationResult> {
    return await this.repository.updateZohoCreditNote(
      creditNoteId,
      creditNoteData
    );
  }
}
